<template>
  <el-pagination
    class="center mt30"
    background
    :current-page="modelvalue"
    layout="prev, pager, next"
    :total="total"
    :page-size="pageSize"
    hide-on-single-page
    @current-change="change"
  >
  </el-pagination>
</template>

<script>
export default {
  name: "myPagination",
  model: {
    prop: "modelvalue",
    event: "change",
  },
  props: {
    total: Number,
    pageSize: {
      type: Number,
      default: 10,
    },
    modelvalue: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      pageIndex: this.modelvalue,
    };
  },
  methods: {
    change(index) {
      this.$emit("change", index);
    },
  },
};
</script>

<style lang="scss" scoped></style>
